import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminAuth({ setIsAuthenticated, setUser }) {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	async function handleSubmit(e) {
		e.preventDefault();
		setLoading(true);
		setMessage("");
		try {
			const res = await fetch("/api/login", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ email, password }),
				credentials: "include",
			});
			const data = await res.json();
			if (!res.ok || data.type === "error") {
				setMessage(data.message || "Неверный email или пароль");
			} else {
				setIsAuthenticated(true);
				if (setUser && data.data?.user) {
					setUser(data.data.user);
				}
				navigate("/admin/users", { replace: true });
			}
		} catch {
			setMessage("Сетевая ошибка");
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-[70vh] flex items-center justify-center px-4">
			<form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl bg-white/5 border border-white/10 p-8 backdrop-blur">
				<h1 className="text-2xl font-bold text-white mb-6">Вход в админку</h1>
				<label className="block text-sm text-gray-300 mb-2">Email</label>
				<input
					type="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					className="w-full mb-4 rounded-lg bg-gray-900 border border-white/10 px-4 py-3 text-white outline-none focus:border-blue-500"
					required
				/>
				<label className="block text-sm text-gray-300 mb-2">Пароль</label>
				<input
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					className="w-full mb-6 rounded-lg bg-gray-900 border border-white/10 px-4 py-3 text-white outline-none focus:border-blue-500"
					required
				/>
				{message && <div className="text-red-400 text-sm mb-4">{message}</div>}
				<button
					type="submit"
					disabled={loading}
					className="w-full rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-50 transition px-4 py-3 text-white font-medium"
				>
					{loading ? "Вход..." : "Войти"}
				</button>
			</form>
		</div>
	);
}
